<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="part" id="pt01">
<h1 class="pn"><a class="page" id="p13"></a><a class="page" id="p14"></a><a class="xref" href="#/chihoeckner0006#toc">1</a></h1>
<h1 class="pt"><a class="page" id="p15"></a>Storage</h1>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-hoeckner-0009.vue?7688ab34